import gtag from '../analytics/gtag';
import type { User } from '../model/types';
import { includeInCsp } from '../utils/HeaderContext';
import useOnMount from '../utils/useOnMount';

declare const embeddedservice_bootstrap: any;

function makePrechatField(value: string | undefined) {
    return {
        value,
        isEditableByEndUser: !value,
    };
}

export default function SalesforceChat() {
    includeInCsp('script-src', 'https://vinmonopolet.my.site.com/');
    includeInCsp('connect-src', 'https://vinmonopolet.my.salesforce-scrt.com/');
    includeInCsp('style-src', 'https://vinmonopolet.my.site.com/');
    includeInCsp('frame-src', 'https://vinmonopolet.my.site.com/');

    useOnMount(async ({ user }) => {
        // chat only works on vinmonopolets domains
        if (!location.hostname.endsWith('.vinmonopolet.no')) return;
        initializeChat(user);
    });

    return null;
}

function initializeChat(user: Readonly<User> | null) {
    function initEmbeddedMessaging() {
        try {
            embeddedservice_bootstrap.settings.language = 'no'; // For example, enter 'en' or 'en-US'

            window.addEventListener('onEmbeddedMessagingReady', () => {
                embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
                    _firstName: makePrechatField(user?.firstName),
                    _lastName: makePrechatField(user?.lastName),
                    _email: makePrechatField(user?.uid),
                });
            });

            const events = [
                ['onEmbeddedMessageSent', 'chat_wrote'],
                //['onAgentMessage', 'chat_agent_wrote'],
                //['onChasitorMessage', 'chat_customer_wrote'],
                //['onChatEndedByAgent', 'chat_ended'],
                //['onChatEndedByChasitor', 'chat_ended'],
                //['onChatEndedByChatbot', 'chat_ended'],
                ['onEmbeddedMessagingConversationStarted', 'chat_started'],
                ['onEmbeddedMessagingWindowClosed', 'chat_closed'],
                ['onEmbeddedMessagingButtonClicked', 'chat_open'],
            ];

            for (const [event, interaction] of events) {
                window.addEventListener(event, () => {
                    gtag('event', 'livechat', {
                        interaction_type: interaction,
                    });
                });
            }

            // Fires when a page is loaded during business hours. Business hours are specified in the Business Hours record.
            window.addEventListener('onEmbeddedMessagingWithinBusinessHours', () => {
                document.querySelectorAll<HTMLButtonElement>('button[data-launch-chat]').forEach((elm) => {
                    elm.disabled = false;
                    elm.addEventListener('click', (e) => {
                        embeddedservice_bootstrap.utilAPI.launchChat();
                        e.preventDefault();
                        gtag('event', 'livechat', {
                            interaction_type: 'launch_chat_clicked',
                            link_text: elm.textContent,
                        });
                    });
                });
            });

            embeddedservice_bootstrap.init(
                '00D5I000000EdhI',
                'Enhanced_Chat_for_vinmonopolet_no',
                'https://vinmonopolet.my.site.com/ESWEnhancedChatforvinm1758697213215',
                {
                    scrt2URL: 'https://vinmonopolet.my.salesforce-scrt.com',
                },
            );
        } catch (err) {
            console.error('Error loading Embedded Messaging: ', err);
        }
    }

    const s = document.createElement('script');
    s.setAttribute('src', 'https://vinmonopolet.my.site.com/ESWEnhancedChatforvinm1758697213215/assets/js/bootstrap.min.js');
    s.onload = initEmbeddedMessaging;
    document.body.appendChild(s);
}
